import React, { useState, useEffect } from 'react'

import { Page } from 'components'
import { DashboardGraphs } from './components'

import usePermissions from 'hooks/usePermissions'
import permissions from 'constants/permissions'
import * as service from 'service'

import useStyles from './styles'

const Dashboard = () => {
  const classes = useStyles()
  const [gapStats, setGapStats] = useState({})
  const [processStats, setProcessStats] = useState({})
  const [generalStats, setGeneralStats] = useState({})
  const [supplierStats, setSupplierStats] = useState({})
  const [fragilityStats, setFragilityStats] = useState({})
  const [questionControlStats, setQuestionControlStats] = useState({})
  const [trainingStats, setTrainingStats] = useState({})
  const [consentStats, setConsentStats] = useState({})
  const [cookieStats, setCookieStats] = useState([])
  const [privacyPolicyStats, setPrivacyPolicyStats] = useState({})
  const [ticketStats, setTicketStats] = useState({})
  const [complaintStats, setComplaintStats] = useState({})
  const [loading, setLoading] = useState(false)

  const { permitted } = usePermissions()

  const isCookiesAuthenticated = service.cookies.auth.isAuthenticated()
  const isCookiesPermitted = permitted(permissions.COOKIES.MANAGE)

  useEffect(() => {
    const loadStats = async () => {
      try {
        setLoading(true)

        const [
          gapStatsResponse,
          processStatsResponse,
          generalStatsResponse,
          supplierStatsResponse,
          fragilityStatsResponse,
          questionControlResponse,
          consentStatsResponse,
          cookieStatsResponse,
          privacyPolicyStatsResponse,
          ticketStatsResponse,
          complaintStatsResponse,
          trainingStatsResponse,
        ] = await Promise.all([
          service.dponet.myLgpd.getGapStats().catch(() => null),
          service.dponet.myLgpd.getProcessStats().catch(() => null),
          service.dponet.myLgpd.getGeneralStats().catch(() => null),
          service.dponet.myLgpd.getSupplierStats().catch(() => null),
          service.dponet.myLgpd.getFragilityStats().catch(() => null),
          service.dponet.myLgpd.getQuestionControlStats().catch(() => null),
          service.dponet.myLgpd.getConsentStats().catch(() => null),
          isCookiesAuthenticated && isCookiesPermitted
            ? service.cookies.consent.getStatsByBanner().catch(() => null)
            : null,
          service.dponet.myLgpd.getPrivacyPolicyStats().catch(() => null),
          service.dponet.myLgpd.getTicketStats().catch(() => null),
          service.dponet.myLgpd.getComplaintStats().catch(() => null),
          service.dponet.myLgpd.getTrainingStats().catch(() => null),
        ])

        setGapStats(gapStatsResponse?.data?.stats || {})
        setProcessStats(processStatsResponse?.data?.stats || {})
        setGeneralStats(generalStatsResponse?.data?.stats || {})
        setSupplierStats(supplierStatsResponse?.data?.stats || {})
        setFragilityStats(fragilityStatsResponse?.data?.stats || {})
        setQuestionControlStats(questionControlResponse?.data?.stats || {})
        setConsentStats(consentStatsResponse?.data?.stats || {})
        setCookieStats(cookieStatsResponse?.data?.stats || [])
        setPrivacyPolicyStats(privacyPolicyStatsResponse?.data?.stats || {})
        setTicketStats(ticketStatsResponse?.data?.stats || {})
        setComplaintStats(complaintStatsResponse?.data?.stats || {})
        setTrainingStats(trainingStatsResponse?.data?.stats || {})
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }

    loadStats()
    //eslint-disable-next-line
  }, [])

  return (
    <Page className={classes.root} title="Indicadores">
      <DashboardGraphs
        gapStats={gapStats}
        processStats={processStats}
        generalStats={generalStats}
        supplierStats={supplierStats}
        fragilityStats={fragilityStats}
        questionnaires={gapStats?.questionnaires || []}
        questionControlStats={questionControlStats}
        consentStats={consentStats}
        cookieStats={cookieStats}
        privacyPolicyStats={privacyPolicyStats}
        ticketStats={ticketStats}
        complaintStats={complaintStats}
        trainingStats={trainingStats}
        loading={loading}
      />
    </Page>
  )
}

export default Dashboard
